module.exports = __webpack_public_path__ + "static/media/chodba-prizemi-2.29b48a69.jpg";